<template>
  <form class="form" method="post">

    <div id="appProductCreateVueComponent" class="appFontBlack">
      <HeaderApp />
      <div class="appGroupOfDivCreateOrModify">
        <h2>Ajouter un produit</h2>
        <div class="appGroupOfDivNamesAndInput">
          <div class="appGroupOfDivNames">
            <p class="appLabelStyle1">Marque*</p>
            <p class="appLabelStyle1">Catégorie*</p>
            <p class="appLabelStyle1">Désignation*</p>
            <p class="appLabelStyle1">Prix Achat</p>
            <p class="appLabelStyle1">Prix Vente</p>
            <p class="appLabelStyle1">Quantité</p>
          </div>
          <div class="appGroupOfInput">
            <input v-model="marque" type="string" name="marque" class="appInputStyle1" placeholder="Icon,GHD,...">
            <input v-model="category" type="string" name="category" class="appInputStyle1" placeholder="Shampoing, Soin,">
            <input v-model="name" type="string" name="name" class="appInputStyle1" placeholder="Nom du produit">
            <input v-model="priceBuyer" type="number" step=".01" name="priceBuyer" class="appInputStyle1" placeholder="">
            <input v-model="priceSeller" type="number" step=".01" name="priceSeller" class="appInputStyle1"
              placeholder="">
            <input v-model="quantity" type="number" name="quantity" class="appInputStyle1" placeholder="">
          </div>
        </div>
      </div>
      <br>
      <button @click.prevent="createProduct()" type="submit" class="appButtonModel2">Ajouter mon produit</button>
      <div v-show="errorMsg" class="error">{{ errorMsg }}</div>
      <div class="appNote01">
        <p>Note : Un produit sans prix de vente ne peut être sélectionné dans un encaissement</p>
      </div>
    </div>

  </form>
</template>

<script>
// Désactiver le problème du camel case avec jwt-decode
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
import axios from 'axios'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'ProductCreate',
  data () {
    return {
      marque: '',
      category: '',
      name: '',
      quantity: '',
      priceBuyer: '',
      priceSeller: '',
      errorMsg: ''
    }
  },
  methods: {
    createProduct () {
      if (this.marque !== '' && this.category !== '' && this.name !== '') {
        this.errorMsg = ''
        // Si champs tous remplis -Récupérer les données du localStorage
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const decryptedToken = jwt_decode(tokenWithDatas.token)
        axios
          .post('https://privilegia.fr/api/produits', {
            userId: decryptedToken.userId,
            marque: this.marque.toUpperCase(),
            category: this.category,
            name: this.name,
            quantity: this.quantity,
            priceBuyer: this.priceBuyer,
            priceSeller: this.priceSeller
          }, {headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' }})
          .then((response) => {
            window.alert('Nouveau produit ajouté')
            this.$router.push('/App/Products')
          })
          .catch((error) => {
            this.errorMsg = 'Merci de renseigner au minimum la Marque, Catégorie et Désignation'
            console.log(error.response.data)
          })
      } else {
        this.errorMsg = 'Merci de renseigner au minimum la Marque, Catégorie et Désignation'
      }
    }}}

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppProductsCreate.vue